import { isSameParticipantSub, participantEmail } from "./wavePresence.js";
/** Prefer owner email for Yjs block meta (parity iOS `resolveCurrentAuthorName`). */
export function resolveOwnerAuthorName(ownerSub, participants = [], sessionEmail) {
    const fromParticipant = participantEmail(ownerSub, participants);
    if (fromParticipant)
        return fromParticipant;
    const session = sessionEmail?.trim();
    if (session && session.includes("@"))
        return session;
    return ownerSub;
}
export function stampTemplateBlocksForCreation(blocks, authorSub, authorName) {
    const now = new Date().toISOString();
    return blocks.map((block) => {
        const stamped = {
            ...block,
            payload: { ...block.payload },
            createdAt: block.createdAt ?? now,
            updatedAt: block.updatedAt ?? now,
        };
        if (!stamped.payload.authorSub?.trim()) {
            stamped.payload.authorSub = authorSub;
            stamped.payload.authorName = authorName;
        }
        return stamped;
    });
}
export function backfillMissingBlockAuthors(blocks, editor, ctx) {
    if (!isSameParticipantSub(ctx.currentUserSub, ctx.ownerSub))
        return 0;
    let count = 0;
    for (const block of blocks) {
        if (block.payload.authorSub?.trim())
            continue;
        editor.setMetaString(block.id, "authorSub", ctx.ownerSub);
        editor.setMetaString(block.id, "authorName", ctx.ownerAuthorName);
        count += 1;
    }
    return count;
}
/** Replace display-only owner `authorName` (e.g. JWT name) with email for gutter/tooltip parity. */
export function repairOwnerBlockAuthorNames(blocks, editor, ctx) {
    if (!isSameParticipantSub(ctx.currentUserSub, ctx.ownerSub))
        return 0;
    if (!ctx.ownerAuthorName.includes("@"))
        return 0;
    let count = 0;
    for (const block of blocks) {
        const sub = block.payload.authorSub?.trim() ?? "";
        if (!sub || !isSameParticipantSub(sub, ctx.ownerSub))
            continue;
        const name = block.payload.authorName?.trim() ?? "";
        if (name.includes("@"))
            continue;
        if (name === ctx.ownerAuthorName)
            continue;
        editor.setMetaString(block.id, "authorName", ctx.ownerAuthorName);
        count += 1;
    }
    return count;
}
